interface SelectBasketPayload{
  basket_id: string
  shop_id: number
  user_id: number
  party_id: number
}

export class SelectBasketRequest {
  endpointUrl: URL
  data: SelectBasketPayload
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }

  constructor(basketId: string, endpoint: string, shopId: number, userId: number, partyId: number) {
    this.data = { basket_id: basketId, shop_id: shopId, user_id: userId, party_id: partyId }
    this.endpointUrl = new URL(endpoint + 'SelectBasket/', window.location.href)
  }
}
